import classNames, {Argument} from 'classnames';
import * as React from 'react';
import {defineMessages, useIntl} from 'react-intl';
import {ClickItem} from 'src/js/common/types';
import {TranslateUtils} from 'src/js/common/utils';

import {IconButton} from './IconButton';
import styles from './RemoveButton.less';

const I18N = defineMessages({
  REMOVE: {
    id: 'common.removeButton.remove',
    defaultMessage: 'Remove',
    description: 'title text for remove button',
  },
});

interface OwnProps {
  className?: Argument;
  disabled?: boolean;
  iconClass?: string;
  item?: ClickItem;
  titleText?: string;
  removeCallback: (item?: ClickItem) => void;
}

type Props = OwnProps;

export const RemoveButton: React.FC<Props> = (props) => {
  const {
    className = '',
    disabled = false,
    iconClass = 'fas fa-times',
    item,
    removeCallback,
    titleText = 'common.removeButton.remove',
  } = props;

  const intl = useIntl();

  return (
    <IconButton
      item={item}
      className={classNames(className, {[styles.dlRemoveButton]: !disabled})}
      iconClass={iconClass}
      clickCallback={removeCallback}
      disabled={disabled}
      titleText={TranslateUtils.translate(
        {...I18N.REMOVE, id: titleText},
        intl
      )}
    />
  );
};

RemoveButton.displayName = 'RemoveButton';
